import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'operation/api/v1/operation-links';

const store = coreStore.queryStore(coreStore.createCoreStore('operationLink', remoteResource));

export default store;
